import { IconButton, Tooltip } from '@zillow/constellation-10';
import { IconInfoOutline } from '@zillow/constellation-icons';

type Props = {
  bodyContent: string;
};

const InfoTooltip = ({ bodyContent }: Props) => {
  return (
    <Tooltip
      content={bodyContent}
      placement="top"
      trigger={
        <IconButton
          emphasis="bare"
          shape="circle"
          size="md"
          title="More information"
          tone="neutral"
          icon={<IconInfoOutline />}
          css={{ height: 'auto', backgroundColor: 'transparent' }}
        />
      }
    />
  );
};

export default InfoTooltip;
